import React, { useEffect, useState } from 'react';
import { Grid, TextField, Snackbar, Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/es';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import "./LicenseDateRangePicker.css"

const LicenseDateRangePicker = ({ startLabel, endLabel, selectedStartDate, selectedEndDate, handleDateChange, unavailableDateRanges }) => {
    const isDateUnavailable = (date) => {
        // Check if the date falls within any of the unavailable date ranges
        return unavailableDateRanges.some(([start, end]) => date >= start && date <= end);
    };

    const [alertOpen, setAlertOpen] = useState(false);

    useEffect(() => {
        if (selectedStartDate && isDateUnavailable(selectedStartDate)) {
            setAlertOpen(true);
        } else if (selectedEndDate && isDateUnavailable(selectedEndDate)) {
            setAlertOpen(true);
        } else {
            setAlertOpen(false);
        }
    }, [selectedStartDate, selectedEndDate, isDateUnavailable]);


    const handleCloseAlert = () => {
        setAlertOpen(false);
    };

    return (
        <div className="license-date-range-picker">
            <div className="license-date-range-picker-start-date">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                    <DatePicker
                        label={startLabel}
                        value={selectedStartDate}
                        onChange={(date) => handleDateChange(date, 'start')}
                        /* renderInput={(params) => <TextField {...params} />} */
                        slotProps={{ textField: { variant: 'outlined' } }}
                        shouldDisableDate={isDateUnavailable}
                    />
                </LocalizationProvider>
            </div>
            <div className="license-date-range-picker-end-date">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                    <DatePicker
                        label={endLabel}
                        value={selectedEndDate}
                        onChange={(date) => handleDateChange(date, 'end')}
                        /* renderInput={(params) => <TextField {...params} />} */
                        slotProps={{ textField: { variant: 'outlined' } }}
                        shouldDisableDate={isDateUnavailable}
                    />
                </LocalizationProvider>
            </div>
            <div className="license-date-range-picker-alert">
                <Snackbar
                    open={alertOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseAlert}
                    message="Selected date is not available"
                />
            </div>
        </div>
    );
};

export default LicenseDateRangePicker;
